var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPlaylistBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8733 2.24584L14.2719 4.31506L16.7632 4.49168L16.9398 6.98299L19.0091 8.3816L17.9164 10.6274L19.0091 12.8733L16.9398 14.2719L16.7632 16.7632L14.2719 16.9398L12.8733 19.009L10.6275 17.9163L8.38161 19.009L6.983 16.9398L4.4917 16.7632L4.31508 14.2719L2.24586 12.8733L3.33855 10.6274L2.24586 8.3816L4.31508 6.98299L4.4917 4.49168L6.983 4.31506L8.38161 2.24584L10.6275 3.33853L12.8733 2.24584Z",
    fill: "#42A5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6587 8.354L9.87001 12.9009L7.59619 10.6274",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlaylistBadge);
export default __webpack_public_path__ + "static/media/account-playlist-badge.a8ecdb23563a0766b7bdab5740ce5fc0.svg";
export { ForwardRef as ReactComponent };